export default {
  suppliers: [],
  selectedSupplier: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/supplier/state.js